"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ecommerce = void 0;
const get_zaraz_1 = require("./helpers/get-zaraz");
function ecommerce(eventName, parameters) {
    return (0, get_zaraz_1.getZaraz)().ecommerce(eventName, parameters);
}
exports.ecommerce = ecommerce;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZWNvbW1lcmNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2Vjb21tZXJjZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxtREFBK0M7QUEwVS9DLFNBQWdCLFNBQVMsQ0FDdkIsU0FBaUIsRUFDakIsVUFBZ0M7SUFFaEMsT0FBTyxJQUFBLG9CQUFRLEdBQUUsQ0FBQyxTQUFTLENBQUMsU0FBUyxFQUFFLFVBQVUsQ0FBQyxDQUFDO0FBQ3JELENBQUM7QUFMRCw4QkFLQyJ9